/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MachineData } from '../../models/machine-data';

export interface GetStati$Params {
      body: Array<number>
}

export function getStati(http: HttpClient, rootUrl: string, params: GetStati$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MachineData>>> {
  const rb = new RequestBuilder(rootUrl, getStati.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MachineData>>;
    })
  );
}

getStati.PATH = '/api/v1/Machine/GetStati';
